module.exports = __webpack_public_path__ + "media/images/icon__checkmark-aa61e2368c24da69788b8bdcedbcce08.png";